
























































import { UseTabs } from "@/common/composition/use-tabs";
import { ICONS } from "@/common/icons.map";
import { SharedState } from "@/common/state";
import { computed, onMounted, Ref, ref } from "@vue/composition-api";
import Vue from "vue";
import InfoTypesNav from "../../InfoTypesNav.vue";
import draggable from "vuedraggable";
import {
  AppsInsightSeverityLevel,
  Insight,
  SensitivityLevelHelper,
} from "@/common/models";
import RiskCard from "./RiskCard.vue";
import LevelLabel from "@/components/LevelLabel.vue";
export default Vue.extend({
  components: { draggable, InfoTypesNav, RiskCard, LevelLabel },
  setup() {
    const [
      info_types,
      selected_info_type,
      _set_selected_info_type,
      init_info_type,
    ] = UseTabs<{ id: string; name: string; icon: string }>([], 0);

    const riskTypes = computed(() =>
      SharedState.insights.value.filter(
        (l) =>
          l.shareType !== "informationRisk" &&
          l.type === "Compliance" &&
          ["internalInformationExposed", "generic"].includes(l.riskType) &&
          l.infoTypeId == selected_info_type.value?.id
      )
    );

    const risks_for_info_type: Ref<Array<{
      name: string;
      level: number;
      level_name: string;
      items: Insight[];
    }>> = ref([]);

    const items_for_level = (level: AppsInsightSeverityLevel): Insight[] => {
      return riskTypes.value.filter(
        (f) =>
          f.severity ===
          level /*  &&
          f.riskType !== "internalInformationExposed" &&
          f.riskType !== "externalInformationExposed" */
      );
    };

    const set_selected_info_type = (type: {
      id: string;
      name: string;
      icon: string;
    }) => {
      _set_selected_info_type(type);
      risks_for_info_type.value = ["None", "Low", "Medium", "High"]
        .map((level, index) => {
          return {
            level: index,
            // @ts-ignore
            items: items_for_level(level),
            level_name: level,
            name: index == 0 ? "No Risk" : `${level} Severity`,
          };
        })
        .reverse();
    };

    const onAdd = async (ev: {
      to: HTMLElement;
      from: HTMLElement;
      item: HTMLElement;
    }) => {
      const from_severity_num = SensitivityLevelHelper.from_str(
        ev.from.dataset.severity as string
      );
      const toSeverity = ev.to.dataset.severity as AppsInsightSeverityLevel;
      const to_severity_num = SensitivityLevelHelper.from_str(toSeverity);
      if (from_severity_num !== to_severity_num) {
        const itemId = ev.item.dataset.id as string;
        SharedState.updateInsightSeverity({
          id: itemId,
          severity: toSeverity,
          optimistic: true,
        }).then(() => {
          // run it again in case of failure
          // TODO: need to receive here a param like is_success
          // so the I will not run set_selected_info_type without need.
          set_selected_info_type(selected_info_type.value);
        });
        set_selected_info_type(selected_info_type.value);
      }
    };

    onMounted(() => {
      SharedState.onReady(() => {
        const categories = SharedState.l0_known_content_info_types.value
          // @ts-ignore
          .filter((f) => !f.is_restricted)
          .map((d) => ({
            id: d.id,
            name: d.labelName,
            icon: ICONS.L0_ICONS.get(d.code),
          }));
        init_info_type(categories, 0);
        set_selected_info_type(categories[0]);
      });
    });
    return {
      onAdd,
      info_types,
      selected_info_type,
      set_selected_info_type,
      risks_for_info_type,
    };
  },
});
